import { ComplexEnum } from '../../utils/complexEnum'
import {
  DailyInspectionInspection,
  AsphaltLot,
  ConcreteTest,
  ConcreteTestSet,
  DailyInspectionControlPoint,
  DailyInspectionPunchList,
  DensityLot,
} from './instances'

export type IssueReportTypeItem =
  | typeof DailyInspectionInspection
  | typeof AsphaltLot
  | typeof ConcreteTest
  | typeof ConcreteTestSet
  | typeof DailyInspectionControlPoint
  | typeof DailyInspectionPunchList
  | typeof DensityLot

class IssueReportTypeEnum extends ComplexEnum<
  'IssueReportType',
  IssueReportTypeItem,
  IssueReportTypeItem['id']
> {
  readonly typename = 'IssueReportType'
  get values() {
    return [
      this.DailyInspectionInspection,
      this.AsphaltLot,
      this.ConcreteTest,
      this.ConcreteTestSet,
      this.DailyInspectionControlPoint,
      this.DailyInspectionPunchList,
      this.DensityLot,
    ]
  }
  get classTypes() {
    return [...new Set(this.map(({ classType }) => classType))]
  }
  readonly DailyInspectionInspection = DailyInspectionInspection
  readonly AsphaltLot = AsphaltLot
  readonly ConcreteTest = ConcreteTest
  readonly ConcreteTestSet = ConcreteTestSet
  readonly DailyInspectionControlPoint = DailyInspectionControlPoint
  readonly DailyInspectionPunchList = DailyInspectionPunchList
  readonly DensityLot = DensityLot
}

export const IssueReportType = new IssueReportTypeEnum()
